var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFugro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg843",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.4 273.4",
    style: {
      enableBackground: "new 0 0 273.4 273.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#233C4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g841",
    transform: "translate(-57.43,-377.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path833",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M185.4,523.7c-2,0-4.2-2.1-4.2-4.2v-15.2 c0-2.1,2.1-4.2,4.2-4.2h22.8c2,0,4.2,2.1,4.2,4.2v3.4h-12.2c0,0,0-2.2-3.3-2.2c-3.3,0-3.4,2.4-3.4,2.4v8.4c0,0,0,2.7,3.4,2.7 s3.4-3,3.4-3v-1.7H197v-4.1h15.5v13.4h-11.2l-1.1-2c0,0-1.2,2-3.1,2H185.4L185.4,523.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path835",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M217.7,523.7v-23.6h29.8c0,0,4.7,0.4,4.7,4.4v5.6 c0,4-4.7,4.4-4.7,4.4h-2.4l7.5,9.1h-15.3l-7.1-8.2v8.2H217.7L217.7,523.7z M235.9,511.4c0,0,2.4-0.3,2.4-3.2s-2.4-3.2-2.4-3.2h-5.7 v6.5L235.9,511.4L235.9,511.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path837",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M287.9,519.4c0,2.1-2.1,4.2-4.2,4.2l-1.1,0.1h-21.4 c-2,0-4.2-2.1-4.2-4.2v-15.3c0-2.1,2.1-4.2,4.2-4.2h22.4c2,0,4.2,2.1,4.2,4.2V519.4z M276.1,508.2c0,0-0.1-3-3.4-3 c-3.3,0-3.4,3.2-3.4,3.2v7.9c0,0,0,2.7,3.4,2.7s3.4-3,3.4-3L276.1,508.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path839",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M127.8,486.6h28.9v7.2h-19.2c-0.7,0-1.4,0.6-1.4,1.4v4.9H157 v15.7c0,0,0.1,3.3,3.1,3.3s3.1-3.3,3.1-3.3v-15.7h12.2l0,19.4c0,2.1-2.1,4.2-4.2,4.2h-22.6c-2,0-4.2-2.1-4.2-4.2v-14h-8.3V560 l-6.3,10.6l-6.2-10.6v-54.5h-23.3v-5.4h23.3v-9.4c0-2.1,1.9-4.2,4-4.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFugro);
export default __webpack_public_path__ + "static/media/Fugro.ece444e5f4989784e46e20cc672da44a.svg";
export { ForwardRef as ReactComponent };